import React, { useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TextField,
  TablePagination,
} from "@mui/material";

import { Row, Col } from "react-bootstrap";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import Home from "./home/Home";
import OperationReportService from "../Services/Reports/OperationReportService";

function EInvoiceReport() {

  // CURRENT DATE
  const getCurrentDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  // STATES
  const [fromDate, setFromDate] = useState(getCurrentDate());
  const [toDate, setToDate] = useState(getCurrentDate());

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  // PAGINATION
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // SHOW DATA
  const handleShow = async () => {
    try {
      setLoading(true);

      const payload = {
        fromDate: fromDate,
        toDate: toDate,
      };

      const res = await OperationReportService.getEInvoiceReports(payload);

      const requiredData = res.data.map((item) => ({
        consignmentNumber: item.consignmentNumber,
        gst_bill_no: item.gst_bill_no,
        gst_bill_date: item.gst_bill_date,
        e_invoice_status: item.e_invoice_status,
        bill_auditing_status: item.bill_auditing_status,
        irn_no: item.irn_no,
      }));

      setTableData(requiredData);

    } catch (error) {
      console.log(error);
      alert("Error while fetching data");
    } finally {
      setLoading(false);
    }
  };

  // EXPORT EXCEL
  const handleExportExcel = () => {
    if (tableData.length === 0) {
      alert("No Data Found");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(tableData);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "EInvoiceReport"
    );

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(data, "EInvoiceReport.xlsx");
  };

  // PAGINATION FUNCTIONS
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div>

      {/* SIDE BAR */}
      <Home />

      <div style={{ paddingLeft: "80px", paddingRight: "20px" }}>
        <Paper
          elevation={3}
          style={{
            padding: "20px",
            marginTop: "20px",
          }}
        >

          {/* TITLE */}
          <h2
            style={{
              textAlign: "center",
              color: "red",
              fontWeight: "bold",
              marginBottom: "20px",
            }}
          >
            E-INVOICE REPORT
          </h2>

          {/* FILTER SECTION */}
          <Row className="mb-3">

            <Col lg={3}>
              <TextField
                fullWidth
                type="date"
                label="From Date"
                InputLabelProps={{ shrink: true }}
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </Col>

            <Col lg={3}>
              <TextField
                fullWidth
                type="date"
                label="To Date"
                InputLabelProps={{ shrink: true }}
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </Col>

            <Col
              lg={6}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >

              <Button
                variant="contained"
                color="primary"
                onClick={handleShow}
              >
                {loading ? "Loading..." : "Show"}
              </Button>

              <Button
                variant="contained"
                color="success"
                onClick={handleExportExcel}
              >
                Export Excel
              </Button>

            </Col>
          </Row>

          {/* TABLE */}
          <TableContainer
            component={Paper}
            style={{ maxHeight: "500px" }}
          >
            <Table stickyHeader>

              {/* TABLE HEADER */}
              <TableHead>
                <TableRow>

                  <TableCell
                    style={{
                      fontWeight: "bold",
                      background: "#3dc3b1",
                    }}
                  >
                    Consignment Number
                  </TableCell>

                  <TableCell
                    style={{
                      fontWeight: "bold",
                      background: "#3dc3b1",
                    }}
                  >
                    GST Bill No
                  </TableCell>

                  <TableCell
                    style={{
                      fontWeight: "bold",
                      background: "#3dc3b1",
                    }}
                  >
                    GST Bill Date
                  </TableCell>

                  <TableCell
                    style={{
                      fontWeight: "bold",
                      background: "#3dc3b1",
                    }}
                  >
                    E-Invoice Status
                  </TableCell>

                  <TableCell
                    style={{
                      fontWeight: "bold",
                      background: "#3dc3b1",
                    }}
                  >
                    Bill Auditing Status
                  </TableCell>

                  <TableCell
                    style={{
                      fontWeight: "bold",
                      background: "#3dc3b1",
                    }}
                  >
                    IRN No
                  </TableCell>

                </TableRow>
              </TableHead>

              {/* TABLE BODY */}
              <TableBody>

                {tableData
                  .slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                  .map((row, index) => (
                    <TableRow key={index} hover>

                      <TableCell>
                        {row.consignmentNumber}
                      </TableCell>

                      <TableCell>
                        {row.gst_bill_no}
                      </TableCell>

                      <TableCell>
                        {row.gst_bill_date}
                      </TableCell>

                      <TableCell>
                        {row.e_invoice_status}
                      </TableCell>

                      <TableCell>
                        {row.bill_auditing_status}
                      </TableCell>

                      <TableCell>
                        {row.irn_no}
                      </TableCell>

                    </TableRow>
                  ))}

              </TableBody>

            </Table>
          </TableContainer>

          {/* PAGINATION */}
          <TablePagination
            component="div"
            count={tableData.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 50]}
          />

        </Paper>
      </div>
    </div>
  );
}

export default EInvoiceReport;